import { render, staticRenderFns } from "./SyncDraftsExpandedRow.vue?vue&type=template&id=506ee27d"
import script from "./SyncDraftsExpandedRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncDraftsExpandedRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SyncDraftsExpandedRow.vue?vue&type=style&index=0&id=506ee27d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports